/**
 * 
 * @param {string} currency - The country portion of the shop retailer.
 * @returns {string} - Resulting currency code
 */
export function convertCurrency(currency) {
    if (/\-(ad|as|at|ax|be|bl|de|es|fi|fr|gf|gp|gr|ie|it|lu|mc|me|mq|nl|pm|pt|re|si|sk|sm|tf|va|ws|yt)$/i.test(currency)) {
        return 'EUR';
    }
    else if (/\-(bd|by|fm|gu|io|mh|mp|na|pr|pw|tc|um|us|usaf|vg|vi)$/i.test(currency)) {
        return 'USD';
    }
    else if (/\-ae$/i.test(currency)) {
        return 'AED';
    }
    else if (/\-ar$/i.test(currency)) {
        return 'ARS';
    }
    else if (/\-(au|cc|cx|hm|ki|nf|nr|tv)$/i.test(currency)) {
        return 'AUD';
    }
    else if (/\-bg$/i.test(currency)) {
        return 'BGN';
    }
    else if (/\-bo$/i.test(currency)) {
        return 'BOB';
    }
    else if (/\-br$/i.test(currency)) {
        return 'BRL';
    }
    else if (/\-ca$/i.test(currency)) {
        return 'CAD';
    }
    else if (/\-ch$/i.test(currency)) {
        return 'CHF';
    }
    else if (/\-li$/i.test(currency)) {
        return 'CHF';
    }
    else if (/\-cl$/i.test(currency)) {
        return 'CLP';
    }
    else if (/\-cn$/i.test(currency)) {
        return 'CNY';
    }
    else if (/\-co$/i.test(currency)) {
        return 'COP';
    }
    else if (/\-cz$/i.test(currency)) {
        return 'CZK';
    }
    else if (/\-(dk|fo|gl)$/i.test(currency)) {
        return 'DKK';
    }
    else if (/\-eg$/i.test(currency)) {
        return 'EGP';
    }
    else if (/\-(gs|im|je|sh|uk)$/i.test(currency)) {
        return 'GBP';
    }
    else if (/\-hk$/i.test(currency)) {
        return 'HKD';
    }
    else if (/\-hr$/i.test(currency)) {
        return 'HRK';
    }
    else if (/\-hu$/i.test(currency)) {
        return 'HUF';
    }
    else if (/\-(id|tp)$/i.test(currency)) {
        return 'IDR';
    }
    else if (/\-il$/i.test(currency)) {
        return 'ISL';
    }
    else if (/\-(bt|in)$/i.test(currency)) {
        return 'INR';
    }
    else if (/\-jp$/i.test(currency)) {
        return 'JPY';
    }
    else if (/\-kr$/i.test(currency)) {
        return 'KRW';
    }
    else if (/\-lt$/i.test(currency)) {
        return 'LTL';
    }
    else if (/\-(eh|ma)$/i.test(currency)) {
        return 'MAD';
    }
    else if (/\-mx$/i.test(currency)) {
        return 'MXN';
    }
    else if (/\-my$/i.test(currency)) {
        return 'MYR';
    }
    else if (/\-(bv|no|sj)$/i.test(currency)) {
        return 'NOK';
    }
    else if (/\-(ck|nu|nz|pn|tk)$/i.test(currency)) {
        return 'NZD';
    }
    else if (/\-pe$/i.test(currency)) {
        return 'PEN';
    }
    else if (/\-ph$/i.test(currency)) {
        return 'PHP';
    }
    else if (/\-pk$/i.test(currency)) {
        return 'PKR';
    }
    else if (/\-pl$/i.test(currency)) {
        return 'PLN';
    }
    else if (/\-ro$/i.test(currency)) {
        return 'RON';
    }
    else if (/\-rs$/i.test(currency)) {
        return 'RSD';
    }
    else if (/\-ru$/i.test(currency)) {
        return 'RUB';
    }
    else if (/\-sa$/i.test(currency)) {
        return 'SAR';
    }
    else if (/\-se$/i.test(currency)) {
        return 'SEK';
    }
    else if (/\-sg$/i.test(currency)) {
        return 'SGD';
    }
    else if (/\-th$/i.test(currency)) {
        return 'THB';
    }
    else if (/\-tr$/i.test(currency)) {
        return 'TRY';
    }
    else if (/\-tw$/i.test(currency)) {
        return 'TWD';
    }
    else if (/\-ua$/i.test(currency)) {
        return 'UAH';
    }
    else if (/\-ve$/i.test(currency)) {
        return 'VEF';
    }
    else if (/\-vn$/i.test(currency)) {
        return 'VND';
    }
    else if (/\-za$/i.test(currency)) {
        return 'ZAR';
    }
    else {
        return window.cfCheckRSID.cvCurrency;
    }
}